import React from "react";

export default function MenuAssignAcntIcon({ active }) {
  return (
    <svg
      width="28"
      height="22"
      viewBox="0 0 28 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.48206 3.54192C8.48206 5.49818 7.1368 7.08411 5.47739 7.08411C3.81812 7.08411 2.47314 5.49818 2.47314 3.54192C2.47314 1.5858 3.81812 0 5.47739 0C7.1368 0 8.48206 1.5858 8.48206 3.54192Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M8.90206 9.78829C9.11906 9.65624 9.35915 9.57016 9.60779 9.52907C9.10295 8.81806 8.74526 8.05535 8.53862 7.14255C8.48206 6.80898 8.02454 6.76985 7.68434 7.04654C7.04791 7.56443 6.30549 7.91099 5.47725 7.91099C4.63305 7.91099 3.85648 7.57575 3.2339 7.01469C3.03524 6.83554 2.7425 6.80843 2.51388 6.94775C1.33187 7.66854 0.437128 8.81247 0.0468098 10.1712C-0.0580498 10.5352 0.0155915 10.9286 0.244351 11.2316C0.47339 11.5342 0.831229 11.7127 1.21119 11.7127H6.62468C7.27274 10.9665 8.03756 10.315 8.90206 9.78829Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M19.5183 3.54192C19.5183 5.49818 20.8634 7.08411 22.5228 7.08411C24.1824 7.08411 25.5272 5.49818 25.5272 3.54192C25.5272 1.5858 24.1824 0 22.5228 0C20.8634 0 19.5183 1.5858 19.5183 3.54192Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M19.0981 9.78829C18.8811 9.65624 18.6408 9.57016 18.3923 9.52907C18.8972 8.81806 19.2549 8.05535 19.4615 7.14255C19.5182 6.80898 19.9757 6.76985 20.3159 7.04654C20.9524 7.56443 21.6946 7.91099 22.5229 7.91099C23.3669 7.91099 24.1436 7.57575 24.7664 7.01469C24.965 6.83554 25.2576 6.80843 25.4862 6.94775C26.6684 7.66854 27.5633 8.81247 27.9533 10.1712C28.058 10.5352 27.9845 10.9286 27.7559 11.2316C27.5267 11.5342 27.169 11.7127 26.7892 11.7127H21.3754C20.7274 10.9665 19.9627 10.315 19.0981 9.78829Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M22.1866 15.6308C21.5989 13.583 20.2658 11.8515 18.501 10.7409C18.1528 10.5221 17.7009 10.5574 17.392 10.8291C16.4448 11.6618 15.2727 12.1575 14.0001 12.1575C12.7025 12.1575 11.5094 11.6424 10.5525 10.7803C10.247 10.5049 9.79746 10.4634 9.4462 10.6778C7.62943 11.7851 6.25436 13.5431 5.65474 15.6309C5.4936 16.191 5.60658 16.7947 5.95798 17.2606C6.31022 17.726 6.86 18 7.44407 18H20.3972C20.9815 18 21.5317 17.7268 21.8838 17.2606C22.2353 16.7946 22.3477 16.1914 22.1866 15.6308Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M18.6174 5.44312C18.6174 8.4494 16.5502 10.8868 14.0001 10.8868C11.4501 10.8868 9.38306 8.4494 9.38306 5.44312C9.38306 2.43655 11.4501 0 14.0001 0C16.5503 0 18.6174 2.43669 18.6174 5.44312Z"
        fill={active ? "white" : "black"}
      />
      <path
        d="M22 22C24.7614 22 27 19.7614 27 17C27 14.2386 24.7614 12 22 12C19.2386 12 17 14.2386 17 17C17 19.7614 19.2386 22 22 22Z"
        fill={active ? "#111AE9" : "#f5f5f5"}
      />
      <path
        d="M21.5001 18.75C21.4343 18.7504 21.3691 18.7378 21.3081 18.7129C21.2472 18.688 21.1918 18.6513 21.1451 18.605L19.6451 17.105C19.5985 17.0584 19.5615 17.003 19.5363 16.9421C19.511 16.8812 19.498 16.8159 19.498 16.75C19.498 16.6169 19.5509 16.4892 19.6451 16.395C19.7392 16.3008 19.8669 16.248 20.0001 16.248C20.1332 16.248 20.2609 16.3008 20.3551 16.395L21.5001 17.545L23.6451 15.395C23.7392 15.3008 23.8669 15.248 24.0001 15.248C24.1332 15.248 24.2609 15.3008 24.3551 15.395C24.4492 15.4892 24.5021 15.6169 24.5021 15.75C24.5021 15.8832 24.4492 16.0108 24.3551 16.105L21.8551 18.605C21.8084 18.6513 21.753 18.688 21.692 18.7129C21.6311 18.7378 21.5659 18.7504 21.5001 18.75Z"
        fill={active ? "white" : "black"}
      />
    </svg>
  );
}
